import { render, staticRenderFns } from "./SmallAction.vue?vue&type=template&id=2f125165&"
import script from "./SmallAction.vue?vue&type=script&lang=js&"
export * from "./SmallAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports